<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "floorPlanSwiper",
  props: {
    listFloorPlan: Array
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          loop: true
        },
        loop: true,
        on: {
          slideChangeTransitionEnd: function() {
            self.initialSlide = this.activeIndex + 1;
          }
        },
        observer: true,
        observeParents: true
      }
    };
  }
};
</script>

<template>
  <div class="swiper-wrap">
    <swiper
      v-if="listFloorPlan && listFloorPlan.length > 1"
      ref="mySwiper"
      :options="swiperOption"
    >
      <swiper-slide v-for="(item, index) in listFloorPlan" :key="index">
        <div :style="{ backgroundImage: 'url(' + item + ')' }" class="img">
<!--          <img :src="item" style="opacity:0;width:100%;height:100%;object-fit: contain;" />-->
          <el-image :src="item" :style="{ opacity: 0, width: '100%', height: '100%' }"
                    :preview-src-list="listFloorPlan" />
        </div>
      </swiper-slide>
      <div slot="button-prev" class="swiper-button-prev" @click.prevent></div>
      <div slot="button-next" class="swiper-button-next" @click.prevent></div>
    </swiper>
    <swiper
      v-if="listFloorPlan && listFloorPlan.length == 1"
      ref="mySwiper"
      :options="swiperOption"
    >
      <swiper-slide
        v-for="(item, index) in listFloorPlan.concat(listFloorPlan)"
        :key="index"
      >
        <div :style="{ backgroundImage: 'url(' + item + ')' }" class="img">
<!--          <img :src="item" style="opacity:0;width:100%;height:100%;object-fit: contain;" />-->
          <el-image :src="item" :style="{ opacity: 0, width: '100%', height: '100%' }"
                :preview-src-list="listFloorPlan" />
        </div>
      </swiper-slide>
      <div slot="button-prev" class="swiper-button-prev" @click.prevent></div>
      <div slot="button-next" class="swiper-button-next" @click.prevent></div>
    </swiper>
  </div>
</template>

<style scoped>
/*.swiper-button-prev{
    background-image: url('../../assets/p.png');
    background-size: 40px 40px;
    width: 40px;
    height: 40px;
    left: 15px;
}
.swiper-button-next{
    background-image: url('../../assets/n.png');
    background-size: 40px 40px;
    width: 40px;
    height: 40px;
    right: 15px;
}
.swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{
    opacity: 0;
}*/
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/floorPlanSwiper.vue